import moment from 'moment';

export function formatMediumDate(isoString) {
    if (!isoString) return '';
    return moment.utc(isoString).format('MMM D, YYYY');
}

export function getDefaultDateRangePresets() {
    const now = moment();
    const toRange = (start, end) => [start.toDate(), end.toDate()];
    const previousWeek = now.clone().subtract(1, 'week');
    const previousMonth = now.clone().subtract(1, 'month');

    return [
        {
            label: 'Last 7 Days',
            value: toRange(now.clone().subtract(6, 'days'), now.clone()),
            slot: 'preset-date-range-button',
        },
        {
            label: 'Last 30 Days',
            value: toRange(now.clone().subtract(29, 'days'), now.clone()),
            slot: 'preset-date-range-button',
        },
        {
            label: 'Last 90 Days',
            value: toRange(now.clone().subtract(89, 'days'), now.clone()),
            slot: 'preset-date-range-button',
        },
        {
            label: 'Prev. Week',
            value: toRange(
                previousWeek.clone().startOf('isoWeek'),
                previousWeek.clone().endOf('isoWeek')
            ),
            slot: 'preset-date-range-button',
        },
        {
            label: 'Prev. Month',
            value: toRange(
                previousMonth.clone().startOf('month'),
                previousMonth.clone().endOf('month')
            ),
            slot: 'preset-date-range-button',
        },
        {
            label: 'This Week',
            value: toRange(
                now.clone().startOf('isoWeek'),
                now.clone().endOf('isoWeek')
            ),
            slot: 'preset-date-range-button',
        },
        {
            label: 'This Month',
            value: toRange(
                now.clone().startOf('month'),
                now.clone().endOf('month')
            ),
            slot: 'preset-date-range-button',
        },
        {
            label: 'This Year',
            value: toRange(
                now.clone().startOf('year'),
                now.clone().endOf('year')
            ),
            slot: 'preset-date-range-button',
        },
    ];
}
